// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeInviteDeclineBody = {
  inviteId: string;
};

export type typeInviteDeclineOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { outcome: "declined" | "alreadyResolved" };
};

export type typeInviteDeclineOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeInviteDeclineOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeInviteDeclineOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaInviteDeclineBody = {
  type: "object",
  properties: { inviteId: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["inviteId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createInviteDecline(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaInviteDeclineBody);
  }

  return async function postInviteDecline(
    payload: typeInviteDeclineBody,
  ): Promise<typeInviteDeclineOutput200 | typeInviteDeclineOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postInviteDecline" failed before calling the network. #03463a5c2f5e`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#03463a5c2f5e" },
        },
        data: null,
      } as typeInviteDeclineOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/invite/decline`,
      httpMethod: "POST",
      options,
    })) as typeInviteDeclineOutput200 | typeInviteDeclineOutput400;
  };
}
